// src/data/users/UserContext.js

import React, { createContext, useContext, useState } from "react";

const UserContext = createContext();

const initialUsers = [
  {
    id: 1,
    name: "gamze",
    surname: "batur",
    email: "gamzebatur@tuyak.com.tr",
    phone: "5555555555",
    password: "123",
  },
];

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState(initialUsers);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <UserContext.Provider
      value={{
        users,
        setUsers, 
        currentUser,
        setCurrentUser,
        isLoggedIn,
        setIsLoggedIn,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
